import {
  EngagementMedia,
  EngagementMediaType,
  EngagementPlatformType,
  MediaPartType,
  MediaRequestDto,
  ProductListType,
} from '@epicuro-next/data/engagement/engagement-models';
import {
  ListType,
  MediaArgs,
  MediaType,
} from '@epicuro-next/models/engagement';
import { isNullish } from '@epicuro-next/utilities';

export function mapLegacyMediaRequestToEngagement(
  media:
    | MediaArgs
    | (EngagementMedia & {
        mediaPartType?: MediaPartType;
      }),
): MediaRequestDto {
  const { mediaPartType, ...mediaPayload } = media;

  return {
    ...mediaPayload,
    url: media.url,
    name: media.name as string,
    contentType: media.contentType ?? 'image/png',
    ...mapLegacyMediaTypeToEngagement(media.mediaType),
    mediaPart: MediaPartType.MainImage,
    metadata: media.metadata ?? undefined,
  };
}

export function mapLegacyMediaTypeToEngagement(mediaType: MediaType): {
  type: EngagementMediaType;
  platform?: EngagementPlatformType;
} {
  switch (mediaType) {
    case MediaType.Image:
      return { type: EngagementMediaType.Image };
    case MediaType.Livestream:
      return { type: EngagementMediaType.Livestream };
    case MediaType.Directshow:
      return { type: EngagementMediaType.DirectShow };
    case MediaType.Vimeo:
      return {
        type: EngagementMediaType.Video,
        platform: EngagementPlatformType.Vimeo,
      };
    case MediaType.Youtube:
      return {
        type: EngagementMediaType.Video,
        platform: EngagementPlatformType.Youtube,
      };
    case MediaType.Video:
      return {
        type: EngagementMediaType.Video,
        platform: EngagementPlatformType.Native,
      };
  }
}

export function mapLegacyListTypeToEngagement(
  listType?: ListType | null,
): ProductListType {
  if (isNullish(listType)) return ProductListType.Normal;
  if (listType === ListType.Commercial) return ProductListType.Commercial;
  if (listType === ListType.Power) return ProductListType.Power;
  return ProductListType.Normal;
}
